import { chunk } from 'lodash';
import React from 'react';

import { carsOfTheYears } from './helpers';

export default function CarOfTheYearSection({ theme = 'light' }) {
  const isDark = theme === 'dark';

  return (
    <div className="flex flex-col gap-y-1 text-sm">
      <h4 className={`font-semibold mb-0 ${isDark ? 'text-white' : ''}`}>Car Of The Year</h4>
      <ul className={isDark ? 'text-gray-400' : 'text-content-secondary'}>
        {chunk(carsOfTheYears, 2).map((ck, index) => (
          <li key={index}>
            {ck.map((c, i) => (
              <React.Fragment key={i}>
                <a className={`${isDark ? 'text-gray-400 hover:text-gray-300' : 'text-content-secondary'} leading-relaxed`} href={c.url}>
                  {c.year}
                </a>
                {i !== ck.length - 1 ? ' • ' : null}
              </React.Fragment>
            ))}
          </li>
        ))}
      </ul>
    </div>
  );
}
